import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const maintenanceInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // 503 Service Unavailable è lo standard HTTP per la manutenzione
      if (error.status === 503) {
        router.navigate(['/maintenance'], { skipLocationChange: true });
      }
      return throwError(() => error);
    }),
  );
};
